import tableFilter from './table_filter.reducer';

export default tableFilter;


// WEBPACK FOOTER //
// src/main/components/tableFilter/store/reducers/index.js